import type { ICurrencies, IShopShopify } from '~/modules/shopify/types';

import { create } from 'zustand';

export interface IShopifyStoreState {
  shopShopify?: IShopShopify;
  currencies?: ICurrencies;
}

export interface IShopifyStoreActions {
  setShopShopify: (shopShopify: IShopShopify) => void;
  setCurrencies: (currencies: ICurrencies) => void;
}

export interface IShopifyStore extends IShopifyStoreState, IShopifyStoreActions {}

export const useShopifyStore = create<IShopifyStore>()((set) => ({
  shopShopify: undefined,
  currencies: undefined,
  setShopShopify: (shopShopify) => set({ shopShopify }),
  setCurrencies: (currencies) => set({ currencies }),
}));
